/*
PURPOSE: Barrel for the editorial primitive layer.
USE CASES:
- Single import surface for the editorial public-landing pages (Home,
  PublicArtist, ArtistPayoutCollection, ForArtists) and the static legal
  pages.
DOMAIN BOUNDARIES:
- Re-exports only. No logic.
*/

export { default as EditorialSection } from './EditorialSection';
export { default as Eyebrow } from './Eyebrow';
export { default as DisplayHeading } from './DisplayHeading';
export { default as BodyProse } from './BodyProse';
export { default as CtaPill } from './CtaPill';
export { default as EditorialLegalDoc } from './EditorialLegalDoc';
export { default as WhyCoralSection } from './WhyCoralSection';

// Shared editorial CTA override — re-themes JoinCoralButton/CoralButton to the
// warm coral-orange editorial pill without forking the shared component.
export const EDITORIAL_CTA_OVERRIDE =
  '!bg-coral-orange !text-editorial-muted hover:!bg-coral-orange/90 !normal-case !tracking-normal !font-medium !rounded-full';

// Shared editorial text-input styling — warm border, ivory-friendly, editorial
// accent focus ring. Used by the auth surfaces (Login, AuthModal).
export const EDITORIAL_INPUT =
  'w-full rounded-lg border border-editorial-muted/20 bg-white px-4 py-3 ' +
  'text-editorial-body text-editorial-muted placeholder:text-editorial-muted/40 ' +
  'focus:outline-none focus:border-editorial-accent focus:ring-1 focus:ring-editorial-accent';
